import { createFileRoute } from '@tanstack/react-router'
import { CommissionsSection } from '../../../features/commissions/settings-section'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/commissions')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'commissions'),
  component: CommissionsSection,
})
